import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';
import { SEOHead } from '@/components/SEOHead';

const GridBg = () => (
  <div className="absolute inset-0 grid-texture pointer-events-none" aria-hidden="true" />
);

export function Auth() {
  const [form, setForm] = useState({ email: '', access_code: '' });
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className="bg-zinc-950 min-h-screen flex items-center">
      <SEOHead />
      <section className="relative w-full py-24 overflow-hidden">
        <GridBg />
        <div className="container-site relative z-10 max-w-md mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-zinc-900 border border-zinc-800 mb-6">
              <Lock size={18} className="text-amber-500" />
            </div>
            <span className="text-xs font-mono tracking-widest uppercase text-amber-500 block mb-4">
              Restricted Access
            </span>
            <h1 className="font-heading text-3xl font-medium tracking-tight text-zinc-100">
              Document Access
            </h1>
            <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
              Procurement pack documents require verified access.
              Enter your business email and the access code provided in your access confirmation.
            </p>
          </div>

          {submitted ? (
            <div data-testid="auth-success" className="border border-zinc-700 rounded-md p-8 text-center">
              <p className="text-sm text-zinc-300 mb-2">Access request received.</p>
              <p className="text-sm text-zinc-500">If your email is authorized, the document pack will be sent within 1 business day.</p>
            </div>
          ) : (
            <div className="border border-zinc-800 rounded-md p-8 bg-zinc-900/20">
              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-mono tracking-widest uppercase text-zinc-600 mb-2">
                    Business Email <span className="text-amber-500">*</span>
                  </label>
                  <input
                    type="email"
                    value={form.email}
                    onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))}
                    placeholder="you@organization.com"
                    data-testid="auth-email"
                    className="w-full bg-zinc-900 border border-zinc-800 focus:border-amber-500/50 focus:ring-1 focus:ring-amber-500/20 rounded-md px-4 py-3 text-sm text-zinc-200 placeholder:text-zinc-600 outline-none transition-colors duration-200"
                  />
                </div>
                <div>
                  <label className="block text-xs font-mono tracking-widest uppercase text-zinc-600 mb-2">
                    Access Code
                  </label>
                  <input
                    type="text"
                    value={form.access_code}
                    onChange={(e) => setForm((p) => ({ ...p, access_code: e.target.value }))}
                    placeholder="Provided in your access confirmation"
                    data-testid="auth-access-code"
                    className="w-full bg-zinc-900 border border-zinc-800 focus:border-amber-500/50 focus:ring-1 focus:ring-amber-500/20 rounded-md px-4 py-3 text-sm text-zinc-200 placeholder:text-zinc-600 outline-none transition-colors duration-200"
                  />
                </div>
                <button
                  data-testid="auth-submit-btn"
                  disabled={!form.email}
                  onClick={() => setSubmitted(true)}
                  className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-zinc-100 text-zinc-900 rounded-md text-sm font-medium hover:bg-white transition-colors duration-200 disabled:opacity-40 disabled:cursor-not-allowed mt-2"
                >
                  Request Document Access <ArrowRight size={14} />
                </button>
              </div>
              <p className="text-xs text-zinc-600 mt-5 text-center">
                No access code? <Link to="/procurement" className="text-zinc-400 hover:text-zinc-200 underline">Request procurement pack access</Link>
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
